/**
 * client/debug/overlay.ts — network/perf debug overlay (must exist from day one, NET §7.5).
 * OWNER: integration (netcode agent may add fields).
 */
import type { ClientWorld, DebugOverlay, RenderInfo } from '../types';

export class NetDebugOverlay implements DebugOverlay {
  private el: HTMLPreElement | null = null;
  private last = 0;

  mount(root: HTMLElement): void {
    this.el = document.createElement('pre');
    this.el.className = 'debug-overlay';
    root.appendChild(this.el);
  }

  update(world: ClientWorld, fps: number, render: RenderInfo | null): void {
    const now = performance.now();
    if (!this.el || now - this.last < 200) return;
    this.last = now;
    const s = world.stats;
    const o = world.view.origin;
    this.el.textContent =
      `fps ${fps.toFixed(0)}  tick ${s.serverTick}  ping ${s.ping}  [${s.transport}]\n` +
      `delta ${s.delta.toFixed(0)}  lag ${s.renderLag.toFixed(1)}  extrap/s ${s.extrapolationsPerSec}  corr/s ${s.correctionsPerSec} max ${s.maxPredError.toFixed(2)}\n` +
      `snap ${s.snapBytes}B  cmds/pkt ${s.cmdsPerPacket}  players ${world.players.length}  missiles ${world.missiles.length}\n` +
      `pos ${o[0].toFixed(0)} ${o[1].toFixed(0)} ${o[2].toFixed(0)}  yaw ${world.view.viewangles[1].toFixed(1)}` +
      (render ? `\ndraws ${render.drawCalls}  tris ${(render.triangles / 1e6).toFixed(2)}M` : '');
  }

  setVisible(v: boolean): void {
    if (this.el) this.el.style.display = v ? '' : 'none';
  }
}
